uniform float uTime;
uniform sampler2D uNoiseTexture;
uniform sampler2D uColorMap;
uniform sampler2D uNoise2Texture;
uniform sampler2D uNoise3Texture;
uniform vec3 uColorSparks;

in vec2 vUv;
in vec3 worldPosition;
in vec3 worldNormal;
in vec3 viewDirection;
in vec3 viewDirTangent;
in vec3 normals;

#include './lib/uv/uvPolar.glsl'
#include './lib/uv/sphereMask.glsl
#include './lib/uv/uvSkew.glsl'
#include './lib/util/utilNoiseOutline.glsl'

void main()
{

    vec2 uv = vUv;
    vec2 uvWorld = worldPosition.xy;
    // uvWorld *= 0.5 + 0.5;
    float time = uTime;

    float mask1 = sphereMask( uv, vec2( 0.5, 0.5 ), 0.5, 0.34 );
    float mask2 = sphereMask( uv, vec2( 0.5, 0.5 ), 0.4, 0.13 );
    float circle = sphereMask( uv, vec2( 0.5, 0.5 ), 0.5, 0.4 );
    float circle2 = sphereMask( uv, vec2( 0.5, 0.5 ), 0.5, 0.3 );
    float gradientCirlce = length( uv - vec2( 0.5, 0.5 ) );

    
    vec2 uvPole = uvPolar( uv , vec2( 1.0, 5.0 ), vec2( time * 0.17, time * -0.05 ));
    vec2 uvSkewed = uvSkew( uvPole, vec2( 4.0, 1.0 ), true );

    vec2 uvPole2 = uvPolar( uv , vec2( 1.0, 5.0 ), vec2( time * 0.05, time * -0.05 ));
    vec2 uvSkewed2 = uvSkew( uvPole2, vec2( 4.0, 1.0 ), true );

    float noise = texture( uNoiseTexture, uvSkewed - (  circle  * 0.5 )  ).r;
    noise = pow( noise, 20.0 );

    float noise2 = texture( uNoise2Texture, uvPole + (  circle  * 0.05 )  ).r;
    noise2 = pow( noise2, 6.0 );

    float noise3 = texture( uNoise3Texture, uvSkewed2  ).r;
    noise3 *= circle2;
    float noiseBG = step( 0.1, noise3 );

    float noiseEdge = utilNoiseOutline( noise3, 0.1, 0.05, 1 );
    vec4 colorEdge = vec4(1.0);
    colorEdge.rgb * noiseEdge;

    vec3 colorPortalMain = texture( uColorMap, vec2( gradientCirlce ) ).rgb;
    colorPortalMain *= noiseBG;

    float mask = mask1 - mask2;


    vec3 colorNoise = texture( uColorMap, vec2( circle ) ).rgb;


    vec4 dots = texture( uNoiseTexture, uvSkewed - (  circle  * 0.5 )  );
    dots.rgb *= colorNoise;

    float noiseBlink = noise2 * ( sin( time + 7.0  ) * 0.1 ) * 0.5 + 0.5;

    vec4 colorPortal = vec4( dots.rgb * 3.0, mask * noise );
    vec4 colorSparks = vec4( vec3( noise2 * 10.0 ) * uColorSparks, mask * noiseBlink );


    vec4 colorFinal = vec4( colorPortalMain, noiseBG );
    colorFinal = mix( colorFinal, colorEdge, noiseEdge );
    colorFinal = mix( colorFinal, colorPortal, noise * ( 1.0 - mask2 ) );
    colorFinal = mix( colorFinal, colorSparks, noise2 * ( 1.0 - mask2 ) );

    gl_FragColor = colorFinal;


    #include <tonemapping_fragment>
    #include <colorspace_fragment>
    
}